module.exports = __webpack_public_path__ + "362a1a61c39745f080c38accd885d8d4.svg";